import { useLayoutEffect } from "react"

// Not sure about this one. It repositions content and background image
export const useDisableDocumentScroll = () => {
  useLayoutEffect(() => {
    disableDocumentScroll()
    return enableDocumentScroll
  }, [])
}

// [TODO] https://jira.attensi.com/browse/WEB-20831
// This should be handled by using a proper dialog component
const disableDocumentScroll = () => {
  document.body.style.overflow = "hidden"
  // document.body.style.touchAction = "none"
}

const enableDocumentScroll = () => {
  document.body.style.overflow = ""
  // document.body.style.touchAction = ""
}
